import { useQuery } from "@apollo/client";
import { PRODUCT_CATEGORY_QUERY } from "../../../apis/taxonomy/queries";
import { ProductCategoryQueryPayload } from "../../../legacy/types/companySearch/MI";
import { TAXONOMY_CLIENT } from "../../../utils/consts";
import { useNavigate } from "react-router-dom";
import { useMemo } from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { HierarchyDisplay } from "./HierarchyDisplay";
import { OutlinedPaper } from "../../../components/OutlinedPaper";
import { Skeleton } from "../../../components/loading";

export const CategoryHierarchyCard = (props: {
  productName: string;
  categoryNameTree: string[];
}) => {
  const { productName, categoryNameTree } = props;
  const { loading, data } = useQuery<ProductCategoryQueryPayload>(
    PRODUCT_CATEGORY_QUERY,
    {
      context: {
        clientName: TAXONOMY_CLIENT,
      },
    }
  );

  const navigate = useNavigate();

  const categoryIds = useMemo(() => {
    return categoryNameTree
      .map((name) =>
        data?.category.data.find((category) => category.name === name)
      )
      .map((category) => category?.id);
  }, [data, categoryNameTree]);

  return (
    <OutlinedPaper id="category-hierarchy-card" sx={{ p: 2 }}>
      <Typography variant="h4">Category Hierarchy</Typography>
      <Skeleton isLoading={loading} height={140}>
        <HierarchyDisplay>
          {[
            ...categoryNameTree.map((name, index) => {
              return (
                <Typography component="span" variant="body1" key={index}>
                  <Link
                    key={index}
                    href={`/catalog/product/category/${categoryIds[index]}`}
                    underline="none"
                    onClick={(event) => {
                      event.preventDefault();
                      if (categoryIds[index]) {
                        navigate(
                          `/catalog/product/category/${categoryIds[index]}`
                        );
                      }
                    }}
                  >
                    {name}
                  </Link>
                </Typography>
              );
            }),
            <div
              key={categoryNameTree.length}
              style={{ display: "flex", gap: 8, alignItems: "baseline" }}
            >
              <Typography>{productName}</Typography>
              <Typography variant="caption">This product</Typography>
            </div>,
          ]}
        </HierarchyDisplay>
      </Skeleton>
    </OutlinedPaper>
  );
};
